import React from 'react'

import { useHistory, withRouter } from 'react-router-dom'

import {
  Breadcrumbs,
  Div,
  HeaderWithRule,
  NavigationHeader,
} from '@driftt/tide-core'

import './style.css'

const ConnectedHeader = withRouter(NavigationHeader)

const ConnectedNavigationHeader = ({ title, breadcrumbs, headerNav }) => {
  const history = useHistory()
  return (
    <ConnectedHeader
      title={title}
      nav={headerNav}
      history={history}
      secondary={!!breadcrumbs && <Breadcrumbs headings={breadcrumbs} />}
    />
  )
}

const SettingsPageHeader = ({ title, breadcrumbs, headerNav }) => (
  <Div>
    {headerNav ? (
      <ConnectedNavigationHeader
        title={title}
        breadcrumbs={breadcrumbs}
        headerNav={headerNav}
      />
    ) : breadcrumbs ? (
      <NavigationHeader
        title={title}
        secondary={<Breadcrumbs headings={breadcrumbs} />}
      />
    ) : (
      <HeaderWithRule
        classname="settings-page-header"
        title={title}
        headingSize={'h3'}
      />
    )}
  </Div>
)

export default SettingsPageHeader
